import {Line} from './Line';
import {Selectable} from './Selectable';
import {ICloneable, IColorChangeable, IObject3D} from '../Interfaces';

declare const THREE: any;

export class SelectableLine extends Selectable implements IColorChangeable, ICloneable {

  private startPoint;
  private endPoint;
  private color;

  constructor() {
    super();
    this.startPoint = new THREE.Vector3();
    this.endPoint = new THREE.Vector3();
    this.color = new THREE.Color(0x000000);
    this.add(new Line());
  }

  update(startPoint, endPoint) {
    this.startPoint.copy(startPoint);
    this.endPoint.copy(endPoint);
    this.getObjectByName<Line>(Line.Name).update(startPoint, endPoint);
  }

  getBoundingBoxObjects(): Array<any> {
    return [this.getObjectByName(Line.Name)];
  }

  setColor(color): void {
    this.color = color;
    this.getObjectByName<Line>(Line.Name).setColor(color);
  }

  duplicate(): IObject3D {
    const result = new SelectableLine();
    result.update(this.startPoint, this.endPoint);
    result.setColor(this.color);
    return result;
  }

}




// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/SelectableLine.ts